module.exports = __webpack_public_path__ + "static/media/logo.e7c21d98.png";